module.exports = "<div class=password-component-group> <span class=password-title></span> <div class=input-box> <div class=\"poptip caps-lock-tips\"> <span class=\"poptip-arrow poptip-arrow-bottom\"><em>◆</em><i>◆</i></span> 键盘大写已锁定 </div> <input class=set-password-input type=password autocomplete=off maxlength=20 /> <i class=default-faker-password style=display:block></i> <span class=password-rule></span> <div class=input-password-warning></div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/util/passwordInput/password-input.html
// module id = 2097
// module chunks = 50